import React from "react";
import { Image, ModalProps } from "react-bootstrap";
import { useTranslation } from "react-i18next";

import "./StreakExpiringModal.scss";
import BottomDrawer from "../../../BottomDrawer/BottomDrawer";
import PrimaryActionButton from "../../../Buttons/PrimaryActionButton/PrimaryActionButton";
import ImageHourglass from "../../../../images/hourglass.svg";

interface StreakExpiringModalProps extends Pick<ModalProps, "show"> {
  time: string;
  onHide?: () => void;
}

function StreakExpiringModal(props: StreakExpiringModalProps) {
  const { time, onHide, show } = props;
  const { t } = useTranslation("common");
  const handleClose = () => onHide?.();

  return (
    <BottomDrawer
      isOpen={!!show}
      onClose={handleClose}
      aria-labelledby="contained-modal-title-vcenter"
      containerClass="streak-expiring-modal"
    >
      <div className="streak-expiring-modal-content">
        <div className="icon-wrapper">
          <Image src={ImageHourglass} alt="hourglass" height={48} width={27} />
        </div>
        <h2 id="contained-modal-title-vcenter">{t("streak_expiring_soon")}</h2>
        <p className="explainer">
          {t("your_streak_resets_in")} {time}.{" "}
          {t("play_a_game_to_keep_your_streak")}!
        </p>
        <PrimaryActionButton
          text={t("got_it")}
          onClick={handleClose}
          buttonClassName="bottom-cta"
        />
      </div>
    </BottomDrawer>
  );
}

export default StreakExpiringModal;
